<mat-drawer-container class="sidenav-container" autosize>
    <mat-drawer (openedChange)="onOpenedChange($event)" #drawer mode="side" position="end" autoFocus="false" mode="over" class="sidenav">
        <div [hidden]="!(type === 'filters')">
            <app-asset-table-column-visibility-filter #stockFilters [columnVisibility]="columnVisibility" assetType="stock" [quantList]="quantList" [dynamicColumns]="dynamicColumns" (columnChanged)="onDynamicColumnChange($event)"></app-asset-table-column-visibility-filter>
        </div>
        <div [hidden]="!(type !== 'filters' && drawlerData)" class="p-48 pe-0">
            <mat-form-field class="example-full-width">
                <mat-label>Search</mat-label>
                <input matInput placeholder="Search for..." [(ngModel)]="drawlerData.searchText" name="searchText">
            </mat-form-field>
            <div class="selection-container">
                <button type="button" mat-button color="primary" (click)="drawlerData.selectAll()">Select all</button>
                <button type="button" mat-button color="primary" (click)="drawlerData.deselectAll()">Deselect all</button>
            </div>

            <mat-label>Choose an option</mat-label>
            <ul>
                <li 
                    *ngFor="let item of drawlerData.list | search: drawlerData.searchText"
                    [hidden]="item.hidden == true || (drawlerData.hideMarked && item.marked == true)">
                    <mat-checkbox
                        (change)="handleCheckboxUpdate(item.id)"
                        [checked]="filters[drawlerData.name] ? filters[drawlerData.name].includes(item.id.toString()) : false"
                    >
                        {{item.name}}
                    </mat-checkbox>
                </li>
            </ul>
            <div class="selection-container bottom-buttons">
                <button type="button" mat-button color="primary" (click)="filterCompanies();drawer.toggle();">OK</button>
                <button type="button" mat-button color="primary" (click)="drawlerData.onPanelCloseOrCancel();drawer.toggle();">Cancel</button>
            </div>
        </div>
    </mat-drawer>
    <div class="ms-8 mr-8 mt-3">
        <a class="header-back" [routerLink]="['/app']">
            <mat-icon inline=true fontSet="fa" fontIcon="fa-arrow-left" aria-label="back"></mat-icon>
            <span>My portfolios</span>
        </a>
    </div>

    <div class="pb-3">
        <mat-horizontal-stepper class="content-stepper portfolio-container" linear #stepper [selectedIndex]="selectedStep" (selectionChange)="stepChange($event)">
            <mat-step>
                <div class="ms-3 mr-3">
                    <h1>Select assets <app-info infoIndex="2"></app-info></h1>
                    <button *ngIf="showUploadBtn" type="button" class="ms-3" mat-flat-button color="primary" (click)="onUploadClick()">Upload</button>
                    <div class="toolbar-buttons">
                        <button type="button" class="next-button" mat-stroked-button color="primary" (click)="onNextClick()">
                            <span>Next</span>
                            <mat-icon inline=true fontIcon="chevron_right" aria-label="new portfolio"></mat-icon>
                        </button>
                      <!--   <button [disabled]="!selected.length" mat-flat-button class="portfolio-cart float-end ms-3" (click)="onPortfolioCartClick()">
                            <mat-icon [matBadge]="selected.length">work</mat-icon>
                        </button> --> 
                    </div>
                </div>
                <div class="card" style="overflow: visible !important;">
                    <div class="card-body">
                        <app-new-portfolio
                                [drawer]="drawer"
                                [list]="list"
                                [selected]="selected"
                                [filterLists]="filterLists"
                                [portfolio]="portfolio"
                                [meta]="meta"
                                [priorityCurrencies]="priorityCurrencies"
                                (nextClick)="onNextClick()"
                                (getFilters)="getFiltersIn($event)"
                                (fetchCompanies)="fetchCompaniesIn($event, 1)"
                                (itemSelect)="onCompanySelect($event)"
                                (selectAll)="onSelectAll($event)"
                                (pageEvent)="onPageEvent($event)"
                                (cartClick)="onPortfolioCartClick()"
                                (startDateChange)="onMaxStartDateChange($event)"
                                (fileUploaded)="onFileUploaded($event)"
                                (selectedSortingChanged)="changeSelectedSorting($event)"
                        ></app-new-portfolio>
                    </div>
                </div>
            </mat-step>
            <mat-step>
                <div class="ms-3 mr-3">
                    <h1>New portfolio <app-info infoIndex="3"></app-info></h1>
                    <div class="toolbar-buttons">
                        <button mat-flat-button type="button" class="next-button ms-3" color="primary" [disabled]="weightSum !== 100" (click)="onSavePortfolioClick(portfolio)"><span class="navigation-button">Save portfolio</span></button>
                        <button class="portfolio-cart float-end ms-3" mat-stroked-button type="button" color="primary" matStepperPrevious>Back</button>
                    </div>
                </div>
                <div class="card" style="overflow: visible !important;">
                    <div class="card-body" style="overflow: visible !important;">
                        <div *ngIf="weightSum !== 100" class="alert alert-warning d-flex align-items-center gap-2 mb-4" role="alert">
                            <mat-icon fontSet="fa" fontIcon="fa-exclamation-triangle"></mat-icon>
                            <span>
                                The total weight of your portfolio is <strong>{{weightSum}}%</strong>, not 100%.
                                Please adjust the individual weights before saving.
                            </span>
                        </div>
                        <div *ngIf="notFoundISINs?.length" class="alert alert-warning d-flex align-items-center gap-2 mb-4" role="alert">
                            <mat-icon fontSet="fa" fontIcon="fa-exclamation-triangle"></mat-icon>
                            <span>
                                <strong>{{notFoundISINs.length}} ISIN{{notFoundISINs.length === 1 ? '' : 's'}} not found</strong> during file upload and could not be added to your portfolio:
                                <span class="font-monospace">{{notFoundISINs.join(', ')}}</span>.
                            </span>
                        </div>

                        <div class="mb-4">
                            <app-manual-portfolio-form
                                    *ngIf="selectedStep == 1"
                                    [portfolio]="portfolio"
                                    [maxStartDate]="max_start_date"
                                    [filterLists]="filterLists"
                                    [selectedCurrencies]="selectedCurrencies"
                                    [hasETF]="hasETF"
                                    (portfolioSave)="onSavePortfolioClick($event)"
                                    (weightChange)="onWeightTypeChange()"
                                    (startDateSet)="onStartDateSet()"
                                    (setAllEqual)="setAllAssetEqual()"
                            ></app-manual-portfolio-form>
                        </div>

                        <div class="card mb-4">
                            <div class="card-body">
                                <app-new-portfolio-select-dialog *ngIf="portfolio" [list]="selected" [portfolio]="portfolio" (itemRemove)="onCompanySelect($event)"></app-new-portfolio-select-dialog>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-step>
        </mat-horizontal-stepper>
    </div>
</mat-drawer-container>
